/* eslint-disable unicorn/prevent-abbreviations */
import { ICompileService } from 'angular';
import { Alert, Confirm, Modal } from '../../scripts/services/modal/modal';

export default class {
	/**
	 * @param {ICompileService} $compile
	 */
	/* @ngInject */
	constructor($injector) {
		this.$injector = $injector;
		this.$compile = $injector.get('$compile');

		this.$onInit();
	}

	// eslint-disable-next-line class-methods-use-this
	$onInit() {
		//
	}

	async showAlert() {
		const alert = new Alert(this.$injector);
		const result = await alert.open({
			title: 'Title',
			body: 'Message',
			accept: {
				label: 'OK',
				type: 'primary',
			},
		});
		// eslint-disable-next-line no-console
		console.log('result', result);
	}

	async showConfirm() {
		const modal = new Confirm(this.$injector);
		const result = await modal.open({
			title: 'Title',
			body: 'Message',
			cancel: {
				label: 'No',
			},
			accept: {
				label: 'Yes',
			},
		});
		// eslint-disable-next-line no-console
		console.log('result', result);
	}

	// eslint-disable-next-line class-methods-use-this
	async showCustomButtons() {
		const modal = new Modal(this.$injector);
		const result = await modal.open({}, {
			title: 'Title',
			body: 'Message',
			buttons: [
				{
					label: 'Button 1',
					action: 'close',
					value: 'button1',
				},
				{
					label: 'Button 2',
					action: 'close',
					value: 'button2',
				},
				{
					label: 'Button 3',
					action: 'close',
					value: 'button3',
				},
			],
		});
		// eslint-disable-next-line no-console
		console.log('result', result);
	}
}
